module.exports = __webpack_public_path__ + "img/181.f4c6b231.jpg";